import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import ActionButton from 'jbc-front/components/ActionButton';
import { CheckCircle, Excluded, Alert } from 'jbc-front/components/icons';

import Balloon from 'src/components/Balloon';
import { EditActionBtn, CancelActionBtn, SaveActionBtn } from 'src/buttons';
import { SimpleConfirmModal } from 'src/components';
import { EMPLOYEE_SHOW } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import { toggleSubjectRevision } from 'src/reducers/reports/notificationOfBaseAmountRevisions';

import styles from './RevisionItemHeader.scss';

class RevisionItemHeader extends React.Component {
  state = {
    isToggleSubjectModalOpen: false
  };

  openToggleSubjectModal = () => {
    this.setState({ ...this.state, isToggleSubjectModalOpen: true });
  };
  closeToggleSubjectModal = () => {
    this.setState({ ...this.state, isToggleSubjectModalOpen: false });
  };

  render() {
    const { revision, formRevision, showMode, changeToEditMode, cancel, save, reset, toggleSubject } = this.props;
    const isSubject = showMode === 'SHOW' ? revision.displaySubjectFlag : formRevision.displaySubjectFlag;
    const isConfirmedAlert = revision.isConfirmedAlert || _.isNull(revision.alertMessage);
    return (
      <div className={styles.container}>
        <div className={styles.labels}>
          <div className={styles.item}>
            スタッフコード{'　'}: <span className={styles.code}>{revision.staffCode}</span>
          </div>
          <div className={styles.item}>
            氏名{'　'}:{' '}
            <span className={styles.name}>
              <a href={concatParamsToUrl(EMPLOYEE_SHOW, { id: revision.employeeId })}>
                {revision.lastName} {revision.firstName}
              </a>
            </span>
          </div>
          {!isConfirmedAlert && (
            <div className={styles.alertWrapper}>
              <div className={styles.alert}>
                <Alert size={22} color={'#F6A623'} />
                <Balloon className={styles.balloon}>
                  <pre>{revision.alertMessage}</pre>
                </Balloon>
              </div>
            </div>
          )}
          <div className={styles.subject}>
            {isSubject && (
              <ActionButton
                className={styles.subjectButton}
                onClick={() => this.openToggleSubjectModal()}
                icon={<CheckCircle size={16} />}
                as="button"
              >
                対象
              </ActionButton>
            )}
            {!isSubject && (
              <ActionButton
                className={styles.subjectButton}
                onClick={() => this.openToggleSubjectModal()}
                icon={<Excluded size={16} />}
                as="button"
              >
                対象外
              </ActionButton>
            )}
          </div>
        </div>
        {showMode === 'SHOW' ? (
          <div className={styles.action}>
            <EditActionBtn onClick={changeToEditMode} />
          </div>
        ) : (
          <div className={styles.action}>
            <ActionButton onClick={reset} as="button" className="u-mr10">
              手入力前に戻す
            </ActionButton>
            <SaveActionBtn onClick={save} className="u-mr10" />
            <CancelActionBtn onClick={cancel} />
          </div>
        )}
        {this.state.isToggleSubjectModalOpen && (
          <SimpleConfirmModal
            isOpen={this.state.isToggleSubjectModalOpen}
            hideModal={this.closeToggleSubjectModal}
            header={'算定基礎対象者の変更'}
            body={
              <div>
                {isSubject && <div>自動判定を無視して対象から外してもよろしいですか。</div>}
                {!isSubject && <div>自動判定を無視して対象に入れてもよろしいですか。</div>}
              </div>
            }
            onClick={() => toggleSubject(revision.id, !revision.displaySubjectFlag)}
            confirmBtnText={isSubject ? '対象外に変更' : '対象に変更'}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({
  toggleSubject: (revisionId, isForceSubject) => {
    dispatch(toggleSubjectRevision(revisionId, isForceSubject));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(RevisionItemHeader);
